import styles from './ComparisonHero.module.css';

export default function ComparisonHero() {
  return (
    <section className={styles.hero}>
      <div className={styles.inner}>
        <span className={styles.eyebrow}>RepBuddy vs the competition</span>
        <h1 className={styles.headline}>An honest comparison, no cheap shots.</h1>

        <p className={styles.positioning}>
          Apollo gives you 1,000 credits and a search UI. RepBuddy gives you 150 contacts
          you can actually email, and does the searching itself.
        </p>

        <span className={styles.stamp}>
          Comparison as of July 2026, based on publicly available pricing.
        </span>
      </div>
    </section>
  );
}
